import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import modal from "./modal.module";
import breadcrumbs from "./breadcrumbs.module";
import actions from "./actions.module";
import profile from "./profile.module";
import signIns from "./signins.module";
import tokens from "./tokens.module";
import statics from "./statics.module";
import destinations from "./destinations.module";
import programs from "./programs.module";
import schedules from "./schedules.module";
import lives from "./lives.module";
import transactions from "./transactions.module";
import channels from "./channels.module";
import files from "./files.module";
import prices from "./prices.module";
import liveReceipts from "./receipts/live.module";
import storageReceipts from "./receipts/storage.module";
import companyStatics from "./company/statics.module";
import companyUsers from "./company/users.module";
import companyPrograms from "./company/programs.module";
import companyDestinations from "./company/destinations.module";
import companyLives from "./company/lives.module";
import companyTickets from "./company/tickets.module";
import adminStatics from "./admin/statics.module";
import adminUsers from "./admin/users.module";
import adminPrograms from "./admin/programs.module";
import adminDestinations from "./admin/destinations.module.js";
import adminLives from "./admin/lives.module";
import adminTransactions from "./admin/transactions.module";
import companies from "./admin/companies.module";
import tickets from "./tickets.module";
// import adminReports from "./admin/reports.module";
import adminTickets from "./admin/tickets.module";
import adminMessages from "./admin/messages.module";
import adminGiftCards from "./admin/giftcards.module";
import banners from "./banners.module";
import adminBanners from "./admin/banners.module";
import companyBanners from "./company/banners.module";
import adminReports from './admin/admin-reports.module';
import userCategory from './user-category.module';
import notification from './notifications.module';
import adminNotifications from './admin/notifications.module';
import userCategoriesReport from "./admin/admin-reports-user-categories.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    modal,
    breadcrumbs,
    actions,
    profile,
    signIns,
    tokens,
    statics,
    destinations,
    programs,
    schedules,
    lives,
    channels,
    transactions,
    files,
    prices,
    liveReceipts,
    storageReceipts,
    companyStatics,
    companyUsers,
    companyPrograms,
    companyDestinations,
    companyLives,
    companyTickets,
    adminStatics,
    adminUsers,
    adminPrograms,
    adminDestinations,
    adminLives,
    adminTransactions,
    companies,
    tickets,
    adminReports,
    adminTickets,
    adminMessages,
    adminGiftCards,
    banners,
    adminBanners,
    companyBanners,
    userCategory,
    notification,
    userCategoriesReport,
    adminNotifications
  },
});
